/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetEntraSyncFailures200ResponseFailuresInner } from './GetEntraSyncFailures200ResponseFailuresInner';
import {
    GetEntraSyncFailures200ResponseFailuresInnerFromJSON,
    GetEntraSyncFailures200ResponseFailuresInnerFromJSONTyped,
    GetEntraSyncFailures200ResponseFailuresInnerToJSON,
    GetEntraSyncFailures200ResponseFailuresInnerToJSONTyped,
} from './GetEntraSyncFailures200ResponseFailuresInner';

/**
 * Successful response
 * @export
 * @interface GetEntraSyncFailures200Response
 */
export interface GetEntraSyncFailures200Response {
    /**
     * 
     */
    failures?: Array<GetEntraSyncFailures200ResponseFailuresInner>;
}

/**
 * Check if a given object implements the GetEntraSyncFailures200Response interface.
 */
export function instanceOfGetEntraSyncFailures200Response(value: object): value is GetEntraSyncFailures200Response {
    return true;
}

export function GetEntraSyncFailures200ResponseFromJSON(json: any): GetEntraSyncFailures200Response {
    return GetEntraSyncFailures200ResponseFromJSONTyped(json, false);
}

export function GetEntraSyncFailures200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEntraSyncFailures200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'failures': json['failures'] == null ? undefined : ((json['failures'] as Array<any>).map(GetEntraSyncFailures200ResponseFailuresInnerFromJSON)),
    };
}

export function GetEntraSyncFailures200ResponseToJSON(json: any): GetEntraSyncFailures200Response {
    return GetEntraSyncFailures200ResponseToJSONTyped(json, false);
}

export function GetEntraSyncFailures200ResponseToJSONTyped(value?: GetEntraSyncFailures200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'failures': value['failures'] == null ? undefined : ((value['failures'] as Array<any>).map(GetEntraSyncFailures200ResponseFailuresInnerToJSON)),
    };
}

